// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var element = "NavItem-module--element--yh-Zb";
export var horizontal = "NavItem-module--horizontal--qfOW-";
export var active = "NavItem-module--active--SC82q";
export var vertical = "NavItem-module--vertical--XU9TE";
export var withSeparator = "NavItem-module--withSeparator--IH4gt";
export var mainNav = "NavItem-module--mainNav--l-H59";
export var activeNav = "NavItem-module--activeNav--88avU";